;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';
import createCookieConsentGatedSentryConfig from '@framework/sentry/createCookieConsentGatedSentryConfig';
import tracesPath from '@/creditflowresearch/infrastructure/sentry/tracesPath';
import { createCookieConsentGatedOTelWebConfig } from '@framework/otel/createCookieConsentGatedOTelWebConfig';

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

createCookieConsentGatedSentryConfig({
  entry: 'creditflowresearch',
  client: true,
  replay: {
    sessionSampleRate: 0,
    onErrorSampleRate: 0.01,
    options: {
      maskAllInputs: false,
      maskAllText: false,
      maxReplayDuration: 15 * 60 * 1000,
      mutationBreadcrumbLimit: 2500,
      mutationLimit: 6000,
    },
    beforeErrorSampling: () => Boolean(Sentry.getCurrentScope().getUser()?.id),
  },
  tracesSampler: (samplingContext) => {
    const op = samplingContext.attributes?.['sentry.op'];
    const path = window.location.pathname;

    if (
      (!op || op === 'pageload' || op === 'navigation') &&
      tracesPath.some((prefix) => path.startsWith(prefix))
    ) {
      return 0.5;
    }

    return 0.01;
  },
});

createCookieConsentGatedOTelWebConfig({ entry: 'creditflowresearch' });
